import React from 'react';
import en from './i18n/en';
import jp from './i18n/jp';
import i18next from 'i18next';

i18next.addResourceBundle('en', 'ctm', en);
i18next.addResourceBundle('jp', 'ctm', jp);


const CtmConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/ctm',
			exact: true,
			component: React.lazy(() => import('./Ctm'))
		},
		{
			path: '/ctm/tft',
			exact: true,
			component: React.lazy(() => import('./Tft'))
		},
		{
			path: '/ctm/tft/pdf',
			exact: true,
			component: React.lazy(() => import('./TftPdf'))
		},
		{
			path: '/ctm/a-measurement',
			//exact: true,
			component: React.lazy(() => import('./AMeasurement'))
		},
		{
			path: '/ctm/info',
			exact: true,
			component: React.lazy(() => import('./Info'))
		},

	]	
};

export default CtmConfig;
